import { namespace as createVuexClass } from 'vuex-class';
import { MasterAccountInfo } from 'ctp-user-auth-service';

export const namespace = 'user';
export const store = createVuexClass(namespace);

export const LIST_MASTER_ACCOUNTS = 'listMasterAccounts';
export const SET_MASTER_ACCOUNT = 'setMasterAccount';
export const SET_CURRENT_USER_DATA = 'setCurrentUserData';
export const SET_ERROR = 'setError';
export const UPDATE_USER_LOCALE = 'updateUserLocale';

export interface IUser {
  name: string;
  email: string;
  roles?: string[];
  locale: string;
}

export interface UserState {
  currentUser?: IUser;
  isLogged: boolean;
  errorMessage: string;
  masterAccounts: Array<MasterAccountInfo>;
  selectedMasterAccount: MasterAccountInfo;
}
